import React, { FC, memo } from "react";

import { SignInFooter } from "./Footer";

import {
  LogoContainer,
  LogoLink,
  LogoTextContainer,
  SignInLeftContainer,
  SignInLeftContent,
  SignInLeftDescription,
  SignInLeftTitle,
  SignInPageContainer,
  SignInRightContainer,
} from "./styled";

import { useLoginScreenSettings } from "../../hooks/useLoginScreenSettings";

const FormContainerComponent: FC = ({ children }) => {
  const { palette, hasContent, logo, title, description, backgroundImage, backgroundVideo, footer, overlay } =
    useLoginScreenSettings();

  const logoContent = (
    <>
      {!!logo?.img && <img src={logo.img} alt={title?.text || ""} />}
      {!!logo?.text && (
        <LogoTextContainer
          fontColor={logo.fontColor}
          fontFamily={logo.fontFamily}
          dangerouslySetInnerHTML={{ __html: logo.text }}
        />
      )}
    </>
  );

  return (
    <SignInPageContainer bgImg={backgroundImage} overlay={overlay} palette={palette}>
      {hasContent && (
        <SignInLeftContainer>
          <LogoContainer>
            {logo?.url ? (
              <LogoLink
                href={logo.url}
                target={logo.blank ? "_blank" : undefined}
                rel={logo.blank ? "noopener noreferrer" : undefined}
              >
                {logoContent}
              </LogoLink>
            ) : (
              logoContent
            )}
          </LogoContainer>
          {(!!title?.text || !!description?.text) && (
            <SignInLeftContent>
              {!!title?.text && (
                <SignInLeftTitle
                  fontSize={title?.fontSize}
                  fontColor={title?.fontColor}
                  fontFamily={title?.fontFamily}
                  dangerouslySetInnerHTML={{ __html: title?.text || "" }}
                />
              )}
              {!!description?.text && (
                <SignInLeftDescription
                  fontColor={description?.fontColor}
                  fontFamily={description?.fontFamily}
                  dangerouslySetInnerHTML={{ __html: description?.text || "" }}
                />
              )}
            </SignInLeftContent>
          )}
          <SignInFooter {...footer} />
        </SignInLeftContainer>
      )}
      <SignInRightContainer>{children}</SignInRightContainer>
      {!!backgroundVideo && (
        <video className="background-video" autoPlay loop muted>
          <source src={backgroundVideo} type="video/mp4" />
        </video>
      )}
      {!hasContent && <SignInFooter {...footer} />}
    </SignInPageContainer>
  );
};

export const FormContainer: FC = memo(FormContainerComponent);
